import { DeprecatedSocialSecurityNumber } from "common/form/inputs/social_security_number";
import { DeprecatedFieldWrapper } from "common/form/enhancers/redux_form_field_wrapper";

/** @deprecated - please use components in common/core/form */
export const DeprecatedSocialSecurityNumberField = DeprecatedFieldWrapper(
  DeprecatedSocialSecurityNumber,
);
